var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-wrap"},[_c('v-chip',{staticClass:"mr-1",attrs:{"x-small":"","color":_vm.formatted.color}}),(!_vm.minimal)?_c('span',{style:({color: _vm.formatted.color})},[_vm._v(_vm._s(_vm.formatted.text || 'NA'))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }